import React, { Fragment, Component } from 'react';
import './radar-chart.scss';
import radar from './radar';
import { defaultOptions } from './radar-default-options';

class RadarChart extends Component {
    render() {
        const {
            data,
            captions,
            options,
            size = defaultOptions.size,
            id
        } = this.props;

        const chartOptions = {
            ...defaultOptions,
            ...options,
            size
        };

        const { setViewBox } = chartOptions;
        const chart = radar(captions, data, chartOptions);

        return (
            <Fragment>
                <div
                    className="radar-tool-tip"
                    id="radar-tool-tip"
                >
                </div>
                <svg
                    className='radar-svg-card'
                    version="1"
                    xmlns="http://www.w3.org/2000/svg"
                    width={size}
                    height={size}
                    viewBox={setViewBox(chartOptions)}
                    id={id}
                >
                    {chart}
                </svg>
            </Fragment>
        );
    }
}

export default RadarChart;
